import React, { useState, useEffect, useRef } from 'react';
import Input from '../Input';
import CheckBox from '../CheckBox';
import MobileInput from '../MobileInput';
import closeIcon from '../../Assets/Icons/close.png';
import pluseIcon from '../../Assets/Icons/Pluse.png';
import { postData, getData } from '../../ApiServices/ApiService';
import { ORG_ADD_CLIENT_CONTACT, ORG_UPDATE_CLIENT_CONTACT } from '../../ApiServices/BaseURL';
import Loader from '../Loader';
import { validateEmail, validateMobileNumber } from '../../Utils/Validation';

const AddNewContactModal = ({ isOpen, onClose, clientId, editData, onValueChange }) => {
  const [contactName, setContactName] = useState(editData?.contact_name || '');
  const [role, setRole] = useState(editData?.contact_role || '');
  const [email, setEmail] = useState(editData?.contact_email || '');
  const [mobileNumber, setMobileNumber] = useState(editData?.contact_phone_no || '');
  const [countryCode, setCountryCode] = useState(editData?.contact_phone_code || '+91');
  const [primaryContact, setPrimartContact] = useState(editData?.is_primary_contact === 1 ? true : false || false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  //console.log('addupdate contact @@@', editData);
  const [contactNameError, setContactNameError] = useState('');
  const [mobileNumberError, setMobileNumberError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [roleError, setRoleError] = useState('');
  const [success,setSuccess] = useState('')


  useEffect(() => {
    //console.log('addupdate contact ', editData);
    if (editData) {
      //console.log('addupdate contact if @@@@', editData)
      setContactName(editData?.contact_name)
      setMobileNumber(editData?.contact_phone_no)
      setCountryCode(editData?.contact_phone_code)
      setEmail(editData?.contact_email)
      setRole(editData?.contact_role)
      setPrimartContact(editData?.is_primary_contact === 1 ? true : false)
    } else {
      resetForm();
    }

  }, [isOpen, editData])

  // Reset form fields to initial values
  const resetForm = () => {
    if (!editData) {
      setContactName('');
      setRole('');
      setEmail('');
      setCountryCode('+91')
      setPrimartContact(false);
      setMobileNumber('');
      setRoleError('');
      setContactNameError('');
      setMobileNumberError('');
      setEmailError('');
    } else {
      setError('');
      setContactNameError('');
      setMobileNumberError('');
      setEmailError('');
      setRoleError('');
      setSuccess('')
    }
  };

  // Run resetForm when modal closes
  useEffect(() => {
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const clearFeilds = () =>{
    setContactName('');
    setRole('');
    setEmail('');
    setCountryCode('+91');
    setPrimartContact(false);
    setMobileNumber('');
  }

  const handleNewContact = async () => {
    try {
      //console.log('handleNewContact countryCode ', countryCode)
      setContactNameError('');
      setMobileNumberError('');
      setEmailError('');
      setRoleError('');
      if (!contactName) {
        setContactNameError("Please enter the contact name");
        return;
      }
      if (!role) {
        setRoleError("Please enter the role");
        return;
      }
      if (!validateEmail(email)) {
        setEmailError("Please enter the valid email");
        return;
      }
      if (!validateMobileNumber(mobileNumber)) {
        setMobileNumberError("Please enter the valid mobile number");
        return;
      }

      setError('');
      setSuccess('')
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "client_id": clientId,
        "contact_name": contactName,
        "contact_phone_no": mobileNumber,
        "contact_email": email,
        "contact_role": role,
        "contact_phone_code": countryCode,
        "is_primary_contact": primaryContact === true ? 1 : 0,
        "action": "client_contact_add"
      }

      //console.log('handleNewContact payload', payLoad);
      // Make the API call
      const response = await postData(ORG_ADD_CLIENT_CONTACT, payLoad);
      const responseData = await response.json();
      //console.log('handleNewContact Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setSuccess(responseData?.info);
            clearFeilds();
            setTimeout(() => {
              handleClose();
              onValueChange();
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to add new contact. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to add new contact.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to add new contact. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Failed to add new contact. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateContact = async () => {
    try {
      //console.log('handleUpdateContact countryCode', countryCode)
      setContactNameError('');
      setMobileNumberError('');
      setEmailError('');
      setRoleError('');
      if (!contactName) {
        setContactNameError("Please enter the contact name");
        return;
      }
      if (!role) {
        setRoleError("Please enter the role");
        return;
      }
      if (!validateEmail(email)) {
        setEmailError("Please enter the valid email");
        return;
      }
      if (!validateMobileNumber(mobileNumber)) {
        setMobileNumberError("Please enter the valid mobile number");
        return;
      }

      setError('');
      setSuccess('')
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "contact_id": editData?.contact_id,
        "contact_name": contactName,
        "contact_phone_no": mobileNumber,
        "contact_email": email,
        "contact_role": role,
        "contact_phone_code": countryCode,
        "is_primary_contact": primaryContact === true ? 1 : 0,
        "action": "client_contact_update"
      }

      //console.log('handleUpdateContact payload', payLoad);
      // Make the API call
      const response = await postData(ORG_ADD_CLIENT_CONTACT, payLoad);
      const responseData = await response.json();
      //console.log('handleUpdateContact Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setSuccess(responseData?.info);
            setTimeout(() => {
              handleClose();
              onValueChange();
            }, 3000);
          } else {
            setError(responseData?.info || 'Failed to update contact. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to update contact.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to update contact. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Failed to update contact. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
    setSuccess('');
  }



  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="Close" style={styles.iconImage} />
        </button>
        {!editData ? <h2 className="modal-title">Add New Contact</h2> :
          <h2 className="modal-title">Update Contact</h2>}
        <hr className="title-divider" />

        <div className="form-grid">
          <Input label="Contact Name" placeholder="Enter Contact Name" value={contactName || ''} onChange={(e) => setContactName(e.target.value)} errorMessage={contactNameError} />
          <Input label="Role" placeholder="Enter Role" value={role || ''} onChange={(e) => setRole(e.target.value)} errorMessage={roleError} />
          <Input label="Email ID" placeholder="Enter Email ID" value={email || ''} onChange={(e) => setEmail(e.target.value)} errorMessage={emailError} />
          {/* <Input label="Phone No." placeholder="Enter mobile number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} /> */}
          <MobileInput
            label="Phone No."
            countryCode={countryCode}
            mobileNumber={mobileNumber || ''}
            onCountryChange={setCountryCode}
            onMobileChange={setMobileNumber}
            placeholder="Enter Phone No."
            countries={[
              { code: "IN", dialCode: "+91" },
              { code: "US", dialCode: "+1" },
              { code: "UK", dialCode: "+44" },
            ]}
            errorMessage={mobileNumberError}
          />

        </div>

        <div className="existing-client-checkbox" style={{marginTop:'20px'}}>
          {primaryContact}
          <CheckBox
            label=""
            checked={primaryContact}
            onChange={(isChecked) => setPrimartContact(isChecked)}
          />
          <label style={styles.exisitingHeading}>Primary Contact</label>
          {/* <input type="checkbox" checked={primaryContact} onChange={(e) => setPrimartContact(e.target.checked)} /> */}

        </div>
        {/* {error && <div style={{ textAlign: 'center', color: 'red' }}> {error} </div>} */}
        <hr className="footer-divider" />

        <div className="button-container" style={{alignItems:'center'}}>
          {!editData ? <button className="add-client-button" onClick={handleNewContact} style={{ opacity: loading ? 0.5 : 1, cursor: loading ? 'not-allowed' : 'pointer', }} disabled={loading}><span style={{ paddingRight: loading ? 10 : 0 }}><Loader loading={loading} color={'#FFFFFF'} size='small' /></span>Add Contact</button> :
            <button className="add-client-button" onClick={handleUpdateContact} style={{ opacity: loading ? 0.5 : 1, cursor: loading ? 'not-allowed' : 'pointer', }} disabled={loading}><span style={{ paddingRight: loading ? 10 : 0 }}><Loader loading={loading} color={'#FFFFFF'} size='small' /></span>Update Contact</button>}
          <button className="cancel-button" onClick={() => { resetForm(); onClose(); }}>Cancel</button>
          {error && <div className="list-error-msg" style={{marginBottom:'3px'}}> {error} </div>}
          {success && <div className="list-success-msg" style={{marginBottom:'3px'}}>{success} </div>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  iconImage: {
    width: '15px',
    height: '15px',
  },
  exisitingHeading: {
    color: '#000',
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: 'Roboto'
  }
}

export default AddNewContactModal;